/* mimosa-wishlist.js — MIMOSA_APPSYNC_v1 (25 Sep 2026)
   Favourites on mimosa.in, kept on the phone (localStorage "mimosa_wish") like the app's list, plus:
     · hearts on collection cards / product page / favourites page  ([data-mimosa-wish])
     · header favourites icon + count                                (#mimosa-wish-icon)
     · "In cart" state on card Add-to-cart buttons                   (theme product-form events, or a re-read after Razorpay handles the add)
     · the Favourites page                                            ([data-mimosa-fav], template page.favourites)
     · hand-off to the app: every link to orders.mimosa.in leaves with ?mcart=<cart>&mwish=<favourites>
       so cart, favourites and the collection she was on all arrive together.
   No server, no account needed. Loaded once from sections/announcement.liquid (defer). */
(function () {
  'use strict';
  if (window.MimosaWish) return;
  var KEY = 'mimosa_wish', APP = 'https://orders.mimosa.in';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ── store ── */
  var items = [];
  function load() { try { var d = JSON.parse(localStorage.getItem(KEY) || '{}'); items = Array.isArray(d.items) ? d.items : []; } catch (e) { items = []; } }
  function save() { try { localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items })); } catch (e) { } }
  function find(h) { for (var i = 0; i < items.length; i++) if (items[i].h === h) return i; return -1; }
  function has(h) { return find(h) >= 0; }
  function add(d) { if (!d || !d.h || has(d.h)) return false; d.at = Date.now(); items.unshift(d); save(); return true; }
  function remove(h) { var i = find(h); if (i < 0) return false; items.splice(i, 1); save(); return true; }
  function skus() { return items.map(function (x) { return x.s; }).filter(Boolean); }
  load();

  /* ── heart buttons ── */
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.4 4.5 7 4.5c2 0 3.4 1.1 5 2.9 1.6-1.8 3-2.9 5-2.9 3.6 0 5.6 3.5 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
  function dataOf(btn) {
    var d = btn.dataset;
    return { h: d.mimosaWish, s: d.sku || '', v: d.vid || '', t: d.title || '', p: +d.price || 0, cp: +d.cprice || 0, i: d.image || '', u: d.url || ('/products/' + d.mimosaWish) };
  }
  function paintBtn(btn) {
    var on = has(btn.dataset.mimosaWish);
    if (!btn.querySelector('svg')) btn.innerHTML = HEART;
    btn.classList.toggle('on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Saved to favourites — tap to remove' : 'Save to favourites');
  }
  function paintHeader() {
    var a = $('#mimosa-wish-icon'); if (!a) return;
    var n = items.length;
    a.classList.toggle('has-items', n > 0);
    a.setAttribute('aria-label', n ? 'Favourites (' + n + ')' : 'Favourites');
    var b = $('#mimosa-wish-bubble', a);
    if (b) b.innerHTML = n ? '<div class="header__cart-count absolute bg-theme-text text-theme-bg text-center"><span aria-hidden="true">' + (n > 99 ? '99+' : n) + '</span></div>' : '';
  }
  function paint() { $$('[data-mimosa-wish]').forEach(paintBtn); paintHeader(); }

  var toastEl, toastT;
  function toast(html, ms) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'mimosa-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html; clearTimeout(toastT);
    requestAnimationFrame(function () { toastEl.classList.add('on'); });
    toastT = setTimeout(function () { toastEl.classList.remove('on'); }, ms || 2600);
  }

  function toggle(btn) {
    var d = dataOf(btn), was = has(d.h);
    if (was) remove(d.h); else add(d);
    paint();
    btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop');
    try { if (!was && window.fbq) fbq('track', 'AddToWishlist', { content_ids: [d.s || d.h], content_type: 'product', value: d.p / 100, currency: 'INR' }); } catch (e) { }
    toast(was ? 'Removed from favourites' : 'Saved to favourites · <a href="/pages/favourites">view all (' + items.length + ')</a>');
    document.dispatchEvent(new CustomEvent('mimosa:wish:change', { detail: { handle: d.h, saved: !was, count: items.length } }));
  }

  document.addEventListener('click', function (e) {
    var ab = e.target.closest && e.target.closest('.mimosa-btn--add'); if (ab) { setTimeout(fetchCart, 1500); setTimeout(fetchCart, 4000); }
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mimosa-wish]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    toggle(btn);
  }, true);

  /* ── cart snapshot (for "In cart" buttons and the app hand-off) ── */
  var cart = { items: [], at: 0 }, cartP = null;
  function fetchCart() {
    cartP = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      cart = { items: (c && c.items) || [], at: Date.now() }; markInCart(); return cart;
    }).catch(function () { return cart; });
    return cartP;
  }
  function inCart(vid) { vid = String(vid); return cart.items.some(function (i) { return String(i.variant_id) === vid || String(i.id) === vid; }); }
  function markInCart() {
    $$('.mimosa-cardrow__add').forEach(function (pf) {
      var id = pf.querySelector('[name="id"]'), btn = pf.querySelector('.mimosa-btn--add'); if (!id || !btn) return;
      var on = inCart(id.value), tx = btn.querySelector('.mimosa-btn__text');
      btn.classList.toggle('mimosa-btn--incart', on);
      if (tx) tx.textContent = on ? 'In cart' : (btn.getAttribute('data-add-to-cart-text') || 'Add to cart');
      var ic = btn.querySelector('.mimosa-btn__tick'); if (ic) ic.hidden = !on;
      var ac = btn.querySelector('.mimosa-btn__plus'); if (ac) ac.hidden = on;
    });
  }
  ['on:cart:add', 'on:line-item:change', 'on:cart:change', 'dispatch:cart-drawer:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var c = e.detail && e.detail.cart;
      if (c && c.items) { cart = { items: c.items, at: Date.now() }; markInCart(); } else setTimeout(fetchCart, 400);
    });
  });

  /* ── hand-off to the app: add ?mcart= & ?mwish= to any orders.mimosa.in link at tap time ── */
  function b64url(s) { try { return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); } catch (e) { return ''; } }
  function withCarry(href) {
    var m = /^([^#]*)(#.*)?$/.exec(href), base = m[1], hash = m[2] || '';
    var q = [];
    var c = cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
    if (c) q.push('mcart=' + b64url(c));
    var w = skus().join(',');
    if (w) q.push('mwish=' + b64url(w));
    if (!q.length) return href;
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + q.join('&') + hash;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf(APP) !== 0 && href.indexOf('//orders.mimosa.in') < 0) return;
    if (a.hasAttribute('data-mimosa-nocarry') || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var go = function () { var u = withCarry(href); (window.MimosaWish && window.MimosaWish.navigate) ? window.MimosaWish.navigate(u) : (location.href = u); };
    if (Date.now() - cart.at < 60000) return go();
    var done = false, fin = function () { if (!done) { done = true; go(); } };
    fetchCart().then(fin, fin); setTimeout(fin, 1500);
  }, true);

  /* ── Favourites page ── */
  function money(paise, fmt) {
    var n = (paise || 0) / 100, s2 = n.toFixed(2), parts = s2.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    fmt = fmt || 'Rs. {{amount}}';
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, whole + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole)
      .replace(/\{\{\s*amount\s*\}\}/g, whole + '.' + parts[1]);
  }
  function img(u, w) { if (!u) return ''; u = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (w || 600); }
  function cardHTML(x, live, fmt, colFrom) {
    var gone = live === null, avail = live ? live.available : true;
    var vid = (live && live.vid) || x.v, sku = (live && live.sku) || x.s, title = (live && live.title) || x.t, url = (live && live.url) || x.u;
    var price = live ? live.price : x.p, cp = live ? live.cp : x.cp, im = (live && live.image) || x.i;
    var trial = APP + '/p/' + encodeURIComponent(sku) + '?trial=1' + colFrom;
    var attrs = ' data-mimosa-wish="' + esc(x.h) + '" data-sku="' + esc(sku) + '" data-vid="' + esc(vid) + '" data-title="' + esc(title) + '" data-price="' + (price || 0) + '" data-cprice="' + (cp || 0) + '" data-image="' + esc(im) + '" data-url="' + esc(url) + '"';
    var add;
    if (gone) add = '<button type="button" class="btn btn--primary mimosa-btn--add" disabled><span class="mimosa-btn__text">Unavailable</span></button>';
    else if (!avail) add = '<button type="button" class="btn btn--primary mimosa-btn--add" disabled><span class="mimosa-btn__text">Sold out</span></button>';
    else add = '<product-form class="mimosa-cardrow__add"><div class="alert bg-error-bg text-error-text js-form-error text-start" role="alert" hidden></div>' +
      '<form method="post" action="/cart/add" class="js-product-form" novalidate="novalidate"><input type="hidden" name="id" value="' + esc(vid) + '" disabled>' +
      '<button type="submit" name="add" class="btn btn--primary mimosa-btn--add" data-add-to-cart-text="Add to cart" aria-haspopup="dialog">' +
      '<span class="mimosa-btn__plus" aria-hidden="true">＋</span><span class="mimosa-btn__tick" aria-hidden="true" hidden>✓</span><span class="mimosa-btn__text">Add to cart</span></button></form></product-form>';
    return '<li class="mimosa-fav__item"><product-card class="card card--product h-full relative flex' + (gone ? ' card--gone' : '') + '">' +
      '<div class="card__media relative"><a href="' + esc(url) + '" class="media block relative js-prod-link" aria-label="' + esc(title) + '">' +
      (im ? '<img class="img-fit img-fit--contain card__main-image" src="' + esc(img(im, 600)) + '" srcset="' + esc(img(im, 460)) + ' 460w, ' + esc(img(im, 700)) + ' 700w, ' + esc(img(im, 900)) + ' 900w" sizes="(min-width: 1280px) 25vw, (min-width: 768px) 33vw, 100vw" alt="' + esc(title) + '" loading="lazy">' : '') +
      '</a><button type="button" class="mimosa-wish on"' + attrs + ' aria-pressed="true">' + HEART + '</button></div>' +
      '<div class="card__info-container flex flex-col flex-auto relative"><div class="card__info w-full"><div class="card__info-inner inline-block w-full">' +
      '<p class="card__title font-bold mt-1 mb-0"><a href="' + esc(url) + '" class="card-link text-current js-prod-link">' + esc(title) + '</a></p>' +
      '<div class="mimosa-card__priceline"><div class="price' + (cp > price ? ' price--on-sale' : '') + '"><div class="price__default"><strong class="price__current">' + esc(money(price, fmt)) + '</strong>' +
      (cp > price ? ' <s class="price__was">' + esc(money(cp, fmt)) + '</s>' : '') + '</div></div><a class="mimosa-card__more" href="' + esc(url) + '">View details ›</a></div>' +
      (gone ? '<p class="mimosa-fav__gone">This saree is no longer on the site.</p>' : (!avail ? '<p class="mimosa-fav__gone">Sold out for now.</p>' : '')) +
      '</div></div><div class="mimosa-cardrow">' + add +
      (gone ? '' : '<a class="btn mimosa-btn--trial" href="' + esc(trial) + '"><span class="mm-star" aria-hidden="true">✦</span><span>See it on you</span></a>') +
      '</div></div></product-card></li>';
  }
  function liveOf(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' }).then(function (r) {
      if (r.status === 404) return null; if (!r.ok) throw new Error(r.status); return r.json();
    }).then(function (p) {
      if (p === null) return null;
      var v = null;
      for (var i = 0; i < (p.variants || []).length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
      v = v || (p.variants && p.variants[0]) || {};
      var fi = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
      return { title: p.title, url: '/products/' + p.handle, vid: v.id, sku: v.sku || '', available: !!p.available, price: v.price != null ? v.price : p.price, cp: v.compare_at_price || p.compare_at_price || 0, image: fi };
    }).catch(function () { return undefined; });   /* undefined = network hiccup → render from the saved copy */
  }
  function favPage(root) {
    var grid = $('[data-fav-grid]', root), empty = $('[data-fav-empty]', root), count = $('[data-fav-count]', root);
    var addAll = $('[data-fav-addall]', root), openApp = $('[data-fav-open]', root), clear = $('[data-fav-clear]', root);
    var fmt = root.getAttribute('data-money-format') || 'Rs. {{amount}}';
    var colFrom = '&c=' + encodeURIComponent('favourites') + '&cn=' + encodeURIComponent('Favourites');
    var LIVE = {};
    function draw() {
      var n = items.length;
      count.textContent = n ? (n + ' saved' + (cart.items.length ? ' · ' + cart.items.length + ' in cart' : '')) : '';
      empty.hidden = n > 0; grid.hidden = n === 0;
      [addAll, openApp, clear].forEach(function (b) { if (b) b.hidden = n === 0; });
      grid.innerHTML = items.map(function (x) { return cardHTML(x, LIVE[x.h] === undefined ? undefined : LIVE[x.h], fmt, colFrom); }).join('');
      markInCart(); paint();
    }
    draw();
    var pending = items.slice();
    pending.forEach(function (x) {
      liveOf(x.h).then(function (l) {
        if (l === undefined) return;               /* keep the saved copy */
        LIVE[x.h] = l;
        if (l) { x.t = l.title; x.p = l.price; x.cp = l.cp; x.i = l.image || x.i; x.v = l.vid; x.s = l.sku || x.s; x.u = l.url; save(); }
        var li = grid.children[find(x.h)]; if (!li) return;
        var t = document.createElement('template'); t.innerHTML = cardHTML(x, l, fmt, colFrom);
        li.replaceWith(t.content.firstChild); markInCart(); paint();
      });
    });
    document.addEventListener('mimosa:wish:change', function (e) {
      if (!e.detail.saved) { var i = -1; $$('.mimosa-fav__item', grid).some(function (li, k) { var b = li.querySelector('[data-mimosa-wish]'); if (b && b.dataset.mimosaWish === e.detail.handle) { i = k; return true; } return false; }); if (i >= 0) grid.children[i].remove(); }
      var n = items.length; count.textContent = n ? n + ' saved' : ''; empty.hidden = n > 0; grid.hidden = n === 0;
      [addAll, openApp, clear].forEach(function (b) { if (b) b.hidden = n === 0; });
    });
    if (clear) clear.addEventListener('click', function () {
      if (!items.length || !confirm('Clear all ' + items.length + ' favourites?')) return;
      items = []; save(); paint(); draw(); toast('Favourites cleared');
    });
    if (addAll) addAll.addEventListener('click', function () {
      var add = [];
      items.forEach(function (x) { var l = LIVE[x.h]; var vid = (l && l.vid) || x.v; var ok = l ? l.available : true; if (vid && ok && !inCart(vid)) add.push({ id: vid, quantity: 1 }); });
      if (!add.length) { toast('Everything here is already in your cart'); if (!rzpOn()) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); return; }
      addAll.classList.add('is-loading'); addAll.setAttribute('aria-disabled', 'true');
      var drawer = $('cart-drawer'), sec = drawer && drawer.closest('.shopify-section');
      var body = { items: add, sections: 'cart-icon-bubble' + (sec ? ',' + sec.id.replace('shopify-section-', '') : ''), sections_url: location.pathname };
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); }).then(function (d) {
          if (d.status) throw new Error(d.description || d.message || 'error');
          return fetchCart().then(function () {
            if (drawer && drawer.renderContents && d.sections) drawer.renderContents(d, !rzpOn());   /* Razorpay's sidecart opens itself on the /cart/add */
            else { var b = $('#cart-icon-bubble'); if (b && d.sections) b.innerHTML = d.sections['cart-icon-bubble']; document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); }
            toast(add.length + (add.length > 1 ? ' sarees' : ' saree') + ' added to your cart');
          });
        }).catch(function (e) { toast('Could not add: ' + esc(e.message || e)); })
        .then(function () { addAll.classList.remove('is-loading'); addAll.removeAttribute('aria-disabled'); draw(); });
    });
  }

  /* ── header: favourites icon beside the cart (injected, so sections/header.liquid stays untouched) ── */
  function mountHeader() {
    var cartIcon = $('#cart-icon'); if (!cartIcon || $('#mimosa-wish-icon')) return;
    var a = document.createElement('a');
    a.className = 'header__icon mimosa-wish-icon relative text-current'; a.id = 'mimosa-wish-icon'; a.href = '/pages/favourites';
    a.setAttribute('aria-label', 'Favourites');
    a.innerHTML = HEART + '<span class="visually-hidden">Favourites</span><div id="mimosa-wish-bubble"></div>';
    cartIcon.parentNode.insertBefore(a, cartIcon);
  }

  /* ── product page: heart on the main photo (injected into .media-gallery__viewer; data from /products/<handle>.js) ── */
  function mountPdp() {
    var viewer = $('#product-media .media-gallery__viewer') || $('.media-gallery__viewer'); if (!viewer || $('.mimosa-wish--pdp', viewer)) return;
    var m = /\/products\/([^\/?#]+)/.exec(location.pathname); if (!m) return;
    var handle = decodeURIComponent(m[1]);
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'mimosa-wish mimosa-wish--pdp';
    b.setAttribute('data-mimosa-wish', handle); b.setAttribute('data-url', '/products/' + handle);
    var h1 = $('.product-title, .product-info h1, h1'); if (h1) b.setAttribute('data-title', h1.textContent.trim());
    var im = $('img', viewer); if (im) b.setAttribute('data-image', (im.currentSrc || im.src || '').split('&width=')[0]);
    b.innerHTML = HEART; viewer.appendChild(b); paintBtn(b);
    liveOf(handle).then(function (l) {
      if (!l) return;
      b.setAttribute('data-sku', l.sku); b.setAttribute('data-vid', l.vid); b.setAttribute('data-title', l.title);
      b.setAttribute('data-price', l.price); b.setAttribute('data-cprice', l.cp || 0); if (l.image) b.setAttribute('data-image', l.image);
      var i = find(handle); if (i >= 0) { var x = items[i]; x.s = l.sku || x.s; x.v = l.vid; x.t = l.title; x.p = l.price; x.cp = l.cp || 0; x.i = l.image || x.i; save(); }
    });
  }

  /* ── Razorpay Magic Sidecart owns the cart wherever it is switched on (live and preview alike) ──
     Its script opens its own drawer on every /cart/add; on a preview theme the theme's own drawer would open as well
     and two drawers appear. So while Razorpay's sidecart is enabled the theme drawer is told not to open after an add
     (theme.settings.afterAtc) and is closed again if anything else opens it. Nothing about Razorpay is changed. */
  function rzpOn() {
    try { var c = document.getElementById('RazorpayMagicSidecartConfig'); if (!c) return false; var j = JSON.parse(c.textContent || '{}'); return !!(j.config && j.config.isEnabled); } catch (e) { return false; }
  }
  function quietThemeDrawer() {
    if (!rzpOn()) return;
    try { if (window.theme && theme.settings && theme.settings.afterAtc === 'drawer') theme.settings.afterAtc = 'nothing'; } catch (e) { }
    document.addEventListener('on:cart-drawer:before-open', function (e) {
      var d = e.target && e.target.closest ? e.target.closest('cart-drawer') : null;
      if (d && d.close) setTimeout(function () { try { d.close(); } catch (x) { } }, 0);
    });
  }

  /* ── boot ── */
  function boot() {
    quietThemeDrawer();
    mountHeader(); mountPdp();
    paint();
    var root = $('[data-mimosa-fav]'); if (root) favPage(root);
    fetchCart();
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { mountHeader(); paint(); markInCart(); }, 120); })
      .observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === KEY) { load(); paint(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.MimosaWish = { items: function () { return items.slice(); }, has: has, add: add, remove: remove, skus: skus, count: function () { return items.length; }, paint: paint, toast: toast, withCarry: withCarry, navigate: function (u) { location.href = u; } };
})();
